import axiosInstance from './axiosConfig';

const API_URL = '/api/kp';

const generateKP = (modules, customData = {}) => {
  return axiosInstance.post(`${API_URL}/generate`, {
    modules,
    customData
  });
};

const calculateKP = (modules, customData = {}, mode = 'modular', projectState = null) => {
  return axiosInstance.post(`${API_URL}/calculate`, {
    modules,
    customData,
    mode,
    projectState
  });
};

const downloadKP = (fileName) => {
  return axiosInstance.get(`${API_URL}/download/${fileName}`, {
    responseType: 'blob'
  });
};

const generateModernPdfKP = (modules, customData = {}, layoutImageBase64) => {
  return axiosInstance.post(`${API_URL}/generate-pdf`, {
    modules,
    customData,
    layoutImageBase64
  });
};

const getHtmlForPdf = (modules, customData = {}, layoutImageBase64 = null) => {
  return axiosInstance.post(`${API_URL}/get-html-for-pdf`, {
    modules,
    customData,
    layoutImageBase64
  });
};


const kpService = {
  generateKP,
  generateModernPdfKP,
  getHtmlForPdf,
  calculateKP,
  downloadKP,
  getSettings: (key = 'standard') => axiosInstance.get(`/api/kp-settings/${key}`),
};

export default kpService;